import { addErrorToast } from '@scouts/ui'

import { ERROR_MESSAGE_GENERIC } from '@/constants'
import { useProfile } from '@/store/profile'

import { useRequestPhoneCallMutation, RequestPhoneCallParams } from '../api'

export const useRequestPhoneCall = () => {
    const { id } = useProfile()
    const [action, { isError, isLoading }] = useRequestPhoneCallMutation()

    const requestPhoneCall = (data: RequestPhoneCallParams) => {
        return action({ ...data, userId: id }).then((response) => {
            if ('error' in response) addErrorToast({ body: ERROR_MESSAGE_GENERIC })
            return response
        })
    }

    return {
        requestPhoneCall,
        isError,
        isLoading,
    }
}
